import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';

/**
 * A small set of mutually exclusive options (a level, a time window). The selected option gets a
 * subtle accent fill rather than a solid primary button, so the page's real primary action keeps
 * the only solid blue.
 */
const SegmentedControl = ({ options, value, onChange, size = 'sm', ariaLabel, className = '' }) => (
  <ButtonGroup size={size} aria-label={ariaLabel} className={`segmented ${className}`.trim()}>
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <Button
          key={option.value}
          variant="outline-secondary"
          className={selected ? 'active' : ''}
          aria-pressed={selected}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      );
    })}
  </ButtonGroup>
);

export default SegmentedControl;
